export const constants = {
  SHOW_LOGIN: 'SHOW_LOGIN',
  SHOW_REGISTER: 'SHOW_REGISTER',
};
